import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LL } from 'i18n/i18n.service';
import { TrendDirection } from '@cf-shared/running-trend';
import { TREND_DIRECTION_COLOR_VARS } from 'components/cs-progress-chart/progress-chart-trend';

/**
 * The legend of the running trend's tunnel colours (#6627): the 4 directions and the dashed
 * "may still change" sample. Shown under every chart that draws a direction-coloured tunnel
 * (`cs-progress-chart`, the Body Composition cards), so the colours read the same everywhere.
 * A colour is the direction of the tunnel only, never the weekly verdict.
 */
@Component({
  selector: 'cs-trend-legend',
  templateUrl: 'cs-trend-legend.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsTrendLegendComponent {
  protected LL = LL;

  /** the entries, each with its tint, in the order the colours are explained */
  protected readonly items = [
    { direction: TrendDirection.Falling, label: LL.progress.trendLegend.falling() },
    { direction: TrendDirection.Rising, label: LL.progress.trendLegend.rising() },
    { direction: TrendDirection.Flat, label: LL.progress.trendLegend.flat() },
    { direction: TrendDirection.Uncertain, label: LL.progress.trendLegend.uncertain() },
  ].map(item => ({ colorVar: `var(${TREND_DIRECTION_COLOR_VARS[item.direction]})`, label: item.label }));
}
